import PropTypes from 'prop-types'
import React from 'react'

import { CompositionsContext } from 'scenes/compositions/base'
import BaseComposition from 'components/Compositions/Composition/base'


export function Composition(props) {
  const { dispatch } = React.useContext(CompositionsContext)

  return <BaseComposition
    {...props}
    onUpdate={item => {
      dispatch({
        type: 'COMPOSITION_UPDATE',
        item,
      })
    }}
    onDelete={() => {
      dispatch({
        type: 'COMPOSITION_DELETE',
        id: props.id,
      })
    }}
    onReload={item => {
      dispatch({
        type: 'COMPOSITION_UPDATE',
        item,
      })
    }}
  />
}

Composition.propTypes = {
  date: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
}
